import { useEffect, useState } from "react";
import { getSeason, updateSeason } from "../../../services/season";
import CreateSeasonForm from "./CreateSeasonForm";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import addSeasonSchema from "../../../schemas/addSeason";
import { getLeagueThemes } from "../../../services/leagues";
import moment from "moment";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

export default function EditSeason({ open, onClose, seasonData, setRefetch }) {
  const [seasonDetails, setSeasonDetails] = useState(null);
  const [themes, setThemes] = useState([]);
  const { id: league_id } = useParams();
  const [loading, setLoading] = useState(false);
  const {
    control,
    getValues,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    ...methods
  } = useForm({
    resolver: yupResolver(addSeasonSchema),
    defaultValues: {
      season_name: "",
      weeks_for_season_games: "",
      week: [],
    },
  });

  const { fields, append, remove, move } = useFieldArray({
    control,
    name: "week",
  });

  const fetchThemes = async () => {
    const response = await getLeagueThemes();
    setThemes(response?.data ? response?.data?.themes : []);
  };

  const fetchSeasonDetails = async () => {
    const response = await getSeason(seasonData.season_id);
    setSeasonDetails(response.data);
  };

  useEffect(() => {
    fetchSeasonDetails();
    fetchThemes();
  }, [seasonData]);

  useEffect(() => {
    setValue("season_name", seasonDetails?.season_name);
    setValue("weeks_for_season_games", seasonDetails?.weeks_for_season_games);
    setValue("week", seasonDetails?.season_weeks || []);
    setValue(
      "start_date",
      seasonDetails?.start_date ? dayjs(seasonDetails.start_date) : null
    );
  }, [seasonDetails]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const objData = {
        league_id: parseInt(league_id),
        season_name: data.season_name,
        start_date: moment(data.start_date).format("YYYY-MM-DD"),
        weeks_for_season_games: data.weeks_for_season_games,
        themes: data.week.map((ele, idx) => ({
          week_number: idx + 1,
          theme_id: parseInt(ele.theme_id),
          is_playoffs: ele.is_playoffs,
          is_finals: ele.is_finals,
        })),
      };

      let res = await updateSeason(seasonData.season_id, objData);
      toast.success(res.message);
      setLoading(false);
      onClose();
      methods.reset();
      setRefetch((data) => !data);
    } catch (err) {
      console.log("err === ", err);
      toast.error(err);
      // setLoading(false);
    }

  };

  const calculateWeekEndDate = (startDate, weekNumber) => {
    return moment(startDate).add(weekNumber * 7, "days");
  };

  return (
    <div>
      {seasonDetails && (
        <CreateSeasonForm
          methods={methods}
          control={control}
          onSubmit={onSubmit}
          loading={loading}
          setCreateSeason={() => {
            setSeasonDetails(null);
            onClose();
          }}
          themes={themes}
          fields={fields}
          watch={watch}
          calculateWeekEndDate={calculateWeekEndDate}
          filteredThemes={themes}
          handleSubmit={handleSubmit}
          isEdit={true}
        />
      )}
    </div>
  );
}
